<!--
 * @Description: 
 * @Author: mTm
 * @Date: 2021-02-26 13:13:53
 * @LastEditTime: 2021-02-26 13:14:25
 * @LastEditors: mTm
-->
<template>
    <h3>asyncComponents</h3>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'App',
});
</script>
<style>
</style>